
export const environment = {
  production: false,
  apiUrl: 'https://web.dev.digivcards.ai/api',
  appUrl: 'https://digivcards.ai',
  logoUrl: 'https://digivcards.ai/public/assets/logo.png',
  companyWebUrl: 'https://tamilarasi.com',
  paymentApiUrl: 'https://digivcards.ai/api/payment',
  webAppUrl: 'https://web.dev.digivcards.ai',
  baseUrl: 'https://digivcards.ai',
  contact: {
    whatsappSupport: '+917550196844',
    whatsappGeneral: '+917550154622',
    supportEmail: 'support@digivcards.ai',
    salesEmail: 'sales@digivcards.ai',
    contactEmail: 'contact@digivcards.ai',
    phoneDisplay: '+91-9876543210',
  },
  appcheck: {
    siteKey: '6LdT1vYrAAAAALaznTlFW12_RrvzAUrquirH23e7',
  },
  firebase: {
    projectId: 'tt-digital-vcard-dev',
    appId: '1:835547657827:web:91aafc912bb079f4056a56',
    storageBucket: 'tt-digital-vcard-dev.firebasestorage.app',
    apiKey: 'AIzaSyDvocB6-A-ZE8-qARvOBFYROEXIzn7J68o',
    authDomain: 'tt-digital-vcard-dev.firebaseapp.com',
    messagingSenderId: '835547657827',
    measurementId: 'G-G9DKCZQB2B',
  },
  apps: {
    android: {
      playStoreUrl: 'https://play.google.com/store/apps/details?id=com.tamilarasi.apps.digivcards',
      packageId: 'com.tamilarasi.apps.digitalcards',
    },
    ios: {
      appStoreUrl: 'https://apps.apple.com/app/digivcard/id123456789',
      appId: 'id1234567890',
    },
  },
  socialMedia: {
    twitter: 'https://twitter.com/tamilarasitech',
    linkedin: 'https://linkedin.com/company/tamilarasitech',
    facebook: 'https://facebook.com/tamilarasitech',
    instagram: 'https://instagram.com/tamilarasitech',
    youtube: 'https://youtube.com/@tamilarasitech',
  },
  company: {
    name: 'Tamilarasi Technologies',
    displayName: 'DiGivCards',
    tagline: 'Professional Digital Visiting Cards',
    description: 'Leading provider of digital visiting card solutions for modern businesses',
    address: {
      street: '1237, 2nd Floor,Subbulakshmi Nagar,Landmark: HDFC Bank',
      city: 'Chennai',
      state: 'Tamil Nadu',
      postalCode: '600132',
      country: 'IN',
      countryName: 'India',
    },
    businessHours: {
      weekdays: {
        open: '09:00',
        close: '18:00',
        timezone: 'Asia/Kolkata',
      },
      weekend: {
        open: null,
        close: null,
      },
    },
    coordinates: {
      latitude: 13.0827,
      longitude: 80.2707,
    },
  },
  externalLinks: {
    companyBlog: 'https://tamilarasi.com/blogs',
    companyAbout: 'https://tamilarasi.com/about',
    companyCareers: 'https://tamilarasi.com/career',
    companyPrivacy: 'https://tamilarasi.com/policies/privacy',
    companyTerms: 'https://tamilarasi.com/terms',
    helpCenter: 'https://tamilarasi.com/support',
    privacyPolicy: 'https://tamilarasi.com/policies/privacy',
    termsOfService: 'https://tamilarasi.com/policies/terms',
    companyHome: 'https://tamilarasi.com/home',
  },
  pricing: {
    basicPlan: {
      price: 3999,
      currency: 'INR',
      currencySymbol: '\u20b9',
    },
  },
  analytics: {
    googleAnalyticsId: 'GA_MEASUREMENT_ID',
    googleTagManagerId: 'GTM_ID',
    facebookPixelId: 'FB_PIXEL_ID',
  },
  features: {
    chatBot: true,
    analytics: true,
    multiLanguage: false,
    darkMode: false,
    nativeApp: false,
  },
  messageTemplates: {
    whatsapp: {
      generalInquiry: 'Hi! I would like to know more about DiGivCards.ai',
      support: 'Hi! I want to get started with DiGivCards. Can you help me?',
      partnership: 'Hi! I want to become an agency partner for DiGivCards. Can you help me with the registration process?',
      sales: "Hi! I'm interested in DiGivCards for my business. Can you provide more information?",
    },
  },
};
